import { DateTime } from "luxon";

export const DateTableCell = ({
  value,
  className = ""
}: {
  value?: string | Date | null;
  className?: string;
  // eslint-disable-next-line sonarjs/function-return-type -- that's ReactNode. We can use it here
}) => {
  const parsed =
    value instanceof Date
      ? DateTime.fromJSDate(value)
      : DateTime.fromISO(value ?? "");
  const date = value ? parsed : null;

  if (!date || !date.isValid) return "--";

  return (
    <p className={className}>
      <time
        dateTime={date.toFormat("yyyy-MM-dd")}
        className="text-sm text-content-500"
      >
        {date.toFormat("MMM d, yyyy")}
      </time>
    </p>
  );
};
